import axios from 'axios'
import { CookiesHelpers } from '@/helpers/helpers'

/**
 * HTTP Instance. Create as many instances
 * as you wish.
 * Also set here all your axios instance options.
 */

const cookies = CookiesHelpers.get()

export const http = axios.create({
  headers: { token: cookies.token },
  baseURL: process.env.VUE_APP_BASE_URL,
})
